import React from "react";
import { ChevronLeft } from "@untitled-ui/icons-react";
import { Button } from '@myhealth-raccoon/components';

export type BackButtonProps = {
    label: string | undefined;
    onClick?(): void;
};

export const BackButton = (({ label, onClick, ...props }: BackButtonProps) => (
    <>
        <div className="block lg:hidden flex-1 pt-1 ml-[-10px]"
            onClick={onClick}>
            <ChevronLeft className="w-10 h-10" /></div>
        <Button
            onClick={onClick}
            className='hidden lg:block flex-1 text-center' color='gray'
            {...props}
        >
            <span>{label}</span>
        </Button>
    </>
));
